<template>
    <div class="twilio-video-call">
        <div class="video-call-wrapper">
            <div class="video-call-container">
                <div id="remoteTrack" class="video-call-display" :class="{ 'doctor': isDoctor }">
                </div>

                <div v-show="isPreviewShown" id="localTrack" class="video-call-thumb-wrapper">
                </div>
                <div class="video-timer-view">
                    {{ timerDisplay }}
                </div>
            </div>
            <div v-if="!started || loading" class="overlay-video-loading">
                <div v-show="!started">
                    {{startText}}
                </div>
                <div v-show="started && loading">
                    {{waitingText}}
                </div>
            </div>
            <div v-if="isEnded" class="overlay-video-loading">
                <div>Video call session ended.</div>
            </div>
        </div>
        <div v-if="!isDoctor" class="video-log-wrapper">
            <template v-if="started && !loading">
                <button class="btn btn-info mb-2" type="button" @click="showHidePreview">{{ showHidePreviewButton }}</button>
            </template>
            <slot></slot>
        </div>
        <!-- <div id="localTrack"></div> -->

        <popup-modal ref="popupErrorVideo" :hasCloseButton="false" title="Failed Starting Video Call Session">
            <template slot="content">
                <p>
                    Unable to access Camera or Microphone.
                </p>
                <p>
                    This video calling feature requires Camera and Microphone permissions, so please allow the Camera and Microphone permission when prompted.
                </p>
                <p>
                    If you are using iOS device, please consider using Safari browser to try again.
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-secondary" @click="dismissError">Okay</button>
            </template>
        </popup-modal>
    </div>
    <!-- <div class="roomTitle">
            <span v-if="loading"> Loading... </span>
            <span v-else-if="!loading"> Connected to Video Call</span>
        </div>
        <div class="video-call-wrapper">

            <div id="" class="video-wrapper">

            </div>
        </div> -->
</template>

<script>
// import { EventBus } from '@/src/events';
// import Twilio, { connect, createLocalTracks, createLocalVideoTrack } from 'twilio-video';
import popupModal from '@/components/popup-modal';
import Video from 'twilio-video';

export default {
    'name': 'TwilioVideo',
    'components': {
        popupModal
    },
    data () {
        return {
            'data': {},
            'remoteTrack': '',
            'activeRoom': '',
            'previewTracks': '',
            'identity': '',
            'participantCount': 0,
            'localTracks': null,
            'isPreviewShown': true,
            'timePassed': 0,
            'timerInterval': null
        };
    },
    'props': ['twilioToken', 'twilioRoomName', 'loading', 'started', 'joined', 'statusText', 'startText', 'waitingText', 'isEnded', 'isDoctor'], // props that will be passed to this component
    'watch': {
        participantCount (participantCount) {
            if (participantCount < 1) {
                this.$emit('update:loading', true);
                clearInterval(this.timerInterval);
            } else {
                this.$emit('update:loading', false);
                this.startTimer();
            }
        }
    },
    created () {
        setInterval(() => {
            let remoteTrackContainer = document.querySelectorAll('#remoteTrack>div');
            this.participantCount = remoteTrackContainer.length;
        }, 1000);
        // setTimeout(() => {
        // this.createChat(this.room_name);
        // }, 5000);
    },
    'computed': {
        showHidePreviewButton () {
            return this.isPreviewShown ? 'Hide Small Screen (Optional)' : 'Show Small Screen (Optional)';
        },
        timerDisplay () {
            return new Date(this.timePassed * 1000).toISOString().substr(11, 8);
        }
    },
    'methods': {
        startTimer () {
            this.timePassed = 0;
            this.timerInterval = setInterval(() => {
                this.timePassed += 1;
            }, 1000);
        },
        showHidePreview () {
            this.isPreviewShown = !this.isPreviewShown;
        },
        participantConnected (participant) {
            // console.log("Joining: '" + participant.identity + "'");

            const div = document.createElement('div');
            div.id = participant.sid;

            participant.on('trackSubscribed', track => this.trackSubscribed(div, track));
            participant.on('trackUnsubscribed', this.trackUnsubscribed);

            participant.tracks.forEach(publication => {
                if (publication.isSubscribed) {
                    this.trackSubscribed(div, publication.track);
                }
            });

            document.getElementById('remoteTrack').appendChild(div);
        },
        participantDisconnected (participant) {
            // console.log('Participant "%s" disconnected', participant.identity);
            document.getElementById(participant.sid).remove();
        },
        trackSubscribed (div, track) {
            div.appendChild(track.attach());
        },
        trackUnsubscribed (track) {
            track.detach().forEach(element => element.remove());
        },

        // Leave Room.
        leaveRoomIfJoined () {
            if (this.activeRoom) {
                this.activeRoom.disconnect();
            }
        },
        startTwilio () {
            this.leaveRoomIfJoined();

            let localTrackPromise = this.localTracks ? Promise.resolve(this.localTracks) : Video.createLocalTracks();

            localTrackPromise.then((tracks) => {
                this.localTracks = tracks;
                const localPreviewContainer = document.getElementById('localTrack');
                this.attachTracks(tracks, localPreviewContainer);

                Video.connect(this.twilioToken, {
                    'name': this.twilioRoomName,
                    'tracks': this.localTracks
                }).then(room => {
                    // console.log('Connected to Room "%s"', room.name);

                    this.$emit('update:joined', true);
                    this.$emit('update:statusText', 'Connected to video call.');

                    // set active toom
                    this.activeRoom = room;

                    room.participants.forEach(this.participantConnected);
                    room.on('participantConnected', this.participantConnected);

                    room.on('participantDisconnected', this.participantDisconnected);

                    room.once('disconnected', () => {
                        this.$emit('update:statusText', 'Disconnected from video call.');
                        this.$emit('update:isEnded', true);
                        room.participants.forEach(this.participantDisconnected);

                        this.localTracks.forEach((track) => {
                            track.stop();
                        });
                        this.localTracks = null;
                    });
                });
            }).catch(() => {
                this.$refs.popupErrorVideo.show();
            });
        },
        attachTrack (track, container) {
            container.appendChild(track.attach());
        },
        attachTracks (tracks, container) {
            tracks.forEach((track) => {
                this.attachTrack(track, container);
            });
        },
        dismissError () {
            this.$refs.popupErrorVideo.hide().then(() => {
                location.reload();
            });
        }
    }
};
</script>

<style>
    #remoteTrack video {
        width: 100% !important;
    }

    #remoteTrack.doctor video {
        height: 190px !important;
    }

    .twilio-video-call {
        display: flex;
        flex-direction: column;
    }

    .video-call-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ccc;
    }

    .video-call-wrapper .overlay-video-loading {
        background-color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .video-call-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .video-timer-view{
        position: absolute;
        right: 10px;
        top: 10px;
        background-color: rgba(0, 0, 0, .75);
        padding: .5rem 1rem;
        color: #fff;
    }

    .video-call-wrapper .video-call-display {
        /* max-height: 480px; */
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
    }

    .video-call-wrapper .video-call-display>video {
        width: 100%;
        display: block;
    }

    .video-call-wrapper .video-call-thumb-wrapper {
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 10px;
    }

    .video-call-wrapper .video-call-thumb-wrapper>video {
        max-height: 100px;
        margin-right: 10px;
        display: block;
    }

    .video-log-wrapper {
        padding: 20px 0;
    }

    @media(min-width: 992px) {
        .twilio-video-call {
            flex-direction: row;
        }

        .video-call-wrapper {
            flex: 1;
        }

        .video-log-wrapper {
            width: 400px;
            padding: 0 20px;
        }
    }
</style>
